const defaultObj = {};

export const getDropdownData = (state) => state.DropdownData.dropdownData.payload || defaultObj;

export const getDropdownLoading = (state) => state.DropdownData.loadingdropdownData;
